__turbopack_context__.v({
  "container": "YoxcUa_container",
  "disabled": "YoxcUa_disabled",
  "fullWidth": "YoxcUa_fullWidth",
  "muiTextArea": "YoxcUa_muiTextArea",
  "textarea": "YoxcUa_textarea",
  "tipTap": "YoxcUa_tipTap",
  "usingBubbleMenu": "YoxcUa_usingBubbleMenu",
});
